import "../../assets/css/re-create-password.css";
import { useState, useEffect, useRef } from "react";
import { RenewPassword } from "../../components/form/RenewPassword";
import { Generic } from "../../components/error/Generic";
import { useSearchParams } from "react-router-dom";
import { checkRecoverPasswordSession } from "../../api/user/userService";
import { SocialBar } from "../../components/socialmedia/SocialBar";


function ReCreatePassword() {
  const [canShowPage, setCanShowPage] = useState(false);
  const [hasError, setHasError] = useState(false);
  const listLinkSocialMedia = useRef({
    socialmedia: { instagram: "", youtube: "", whatsapp: "" },
  });
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [messageError, setMessageError] = useState("");

  function loadLinkPage() {
    fetch("/config.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to load config");
        return res.json();
      })
      .then((data) => {
        listLinkSocialMedia.current = data;
        setHasError(false);
        setCanShowPage(true);
      });
  }

  useEffect(() => {
    
    if (token !== null) {

      checkRecoverPasswordSession(token).then((data) => {
        let statusHttp = data["statusHttp"];
        let message = data["message"];
        switch (statusHttp) {
          case 0:
            setMessageError(message);
            setCanShowPage(false);
            setHasError(true);
            break;
          case 400:
            setMessageError(message);
            setCanShowPage(false);
            setHasError(true);
            break;
          case 404:
            setMessageError(message);
            setCanShowPage(false);
            setHasError(true);
            break;
          case 200:
            loadLinkPage();
            break;
        }
      });
    } else {
      setMessageError(
        "Opa! Esta sessão de recuperação de senha não é mais válida."
      );
      setCanShowPage(false);
      setHasError(true);
    }
  }, []);

  return (
    <>
      {canShowPage === true && typeof token === 'string' ? (
        <div className="d-flex" style={{ minHeight: "100vh" }}>
          <div id="re-create-password-container-form">

          <div className="re-create-password-container-mobile">
            <SocialBar
            instagramUrl={listLinkSocialMedia.current.socialmedia.instagram}
            youtubeUrl={listLinkSocialMedia.current.socialmedia.youtube}
            whatsappUrl={listLinkSocialMedia.current.socialmedia.whatsapp}
            />
            </div>
          
            <RenewPassword token={token} />
          </div>
          <div
            id="re-create-password-container-welcome"
            className="w-100 bg-dark"
          >
            <SocialBar
              instagramUrl={listLinkSocialMedia.current.socialmedia.instagram}
              youtubeUrl={listLinkSocialMedia.current.socialmedia.youtube}
              whatsappUrl={listLinkSocialMedia.current.socialmedia.whatsapp}
            />
          </div>
        </div>
      ) : hasError === true ? (
        <Generic message={messageError} />
      ) : (
        ""
      )}
    </>
  );
}

export default ReCreatePassword;
